import React from 'react';
import { KPIDashboard } from '../components/manager/KPIDashboard';
import { LOCard } from '../components/manager/LOCard';
import { useData } from '../context/DataContext';
import { exportReviewsToCsv } from '../utils/exportReport';
export function ManagerView() {
  const {
    loanOfficers,
    managers,
    selectedWeek
  } = useData();
  // Simulate logged-in manager (Sarah Jenkins)
  const currentManagerId = 'm1';
  const myLOs = loanOfficers.filter(lo => lo.managerId === currentManagerId);
  const handleExport = () => exportReviewsToCsv(myLOs, managers, selectedWeek, 'my-team-accountability-report');
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-345">
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-346">
        <div data-id="element-347">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-348">
            My Team Accountability
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-349">
            Manage weekly reviews and coaching activities for your direct
            reports.
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex space-x-3" data-id="element-350">
          <button onClick={handleExport} className="px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50" data-id="element-351">
            Export My Team
          </button>
        </div>
      </div>

      <KPIDashboard managerId={currentManagerId} data-id="element-352" />

      <div className="mt-8" data-id="element-353">
        <div className="flex items-center justify-between mb-4" data-id="element-354">
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-355">
            Loan Officers ({myLOs.length})
          </h2>
          <div className="flex space-x-2" data-id="element-356">
            <select className="text-sm border-slate-200 rounded-lg py-2 pl-3 pr-8 focus:ring-slate-900 focus:border-slate-900" data-id="element-357">
              <option data-id="element-358">All Statuses</option>
              <option data-id="element-359">Completed</option>
              <option data-id="element-360">In Progress</option>
              <option data-id="element-361">Not Started</option>
            </select>
          </div>
        </div>

        <div className="space-y-4" data-id="element-362">
          {myLOs.map(lo => <LOCard key={lo.id} lo={lo} data-id="element-363" />)}
        </div>
      </div>
    </div>;
}